// docs: https://github.com/altostra/type-validations#readme
import { anyOf, objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { string, nullValidation, number } from "@altostra/type-validations/lib/primitives";

export const isCompaniesCompanyIdCustomRolesDuplicateCustomRoleResult = objectOf({
  custom_role: objectOf({
    id: string,
    name: string,
    permissions: arrayOf(
      objectOf({
        company_id: string,
        app_group_id: string,
        territory_id: anyOf(string, nullValidation),
        scope_id: string,
        scope: number,
        name: number,
      })
    ),
    permission_set_assignments: arrayOf(
      objectOf({
        agps_id: string,
        ag_id: string,
      })
    ),
    number_of_assignee_developers: number,
    scim_groups: maybe(arrayOf(string)),
  }),
});
